import { Inbox } from "lucide-react";
import { cn } from "@/lib/utils";

export function EmptyState({
  className,
  title = "Nothing here yet",
  description,
  icon,
}: {
  className?: string;
  title?: string;
  description?: string;
  icon?: React.ReactNode;
}) {
  return (
    <div className={cn("flex flex-col items-center justify-center gap-3 px-6 py-16 text-center", className)}>
      <div className="grid h-10 w-10 place-items-center rounded-full bg-muted/50 text-muted-foreground">
        {icon ?? <Inbox className="h-5 w-5" />}
      </div>
      <div>
        <p className="text-sm font-medium">{title}</p>
        {description && <p className="mt-1 max-w-sm text-xs text-muted-foreground">{description}</p>}
      </div>
    </div>
  );
}
